<template>

  <!-- app-layer {admin} -->
  <div class="app-layer admin" @click="layerClick($event)">

    <transition name="right-modal" v-show="show">

      <div class="modal-custom right" name="user-credentials" v-if="show" :class="{loading: loading}">

        <span class="close" @click="closeModal()">chiudi</span>

        <h4 class="mt-0 title is-4 uc">Credenziali utente</h4>

        <div class="credentials">

          <ul v-if="customer.credenziali && customer.credenziali.length > 0" class="credentials-list">

            <li v-for="credential in customer.credenziali" :key="credential.id">

              <single-credential :credential="credential" :addresses="customer.indirizzi" />

            </li>

          </ul>

          <p v-else class="empty">Ancora nessuna credenziale creata per questo utente...</p>

        </div>

        <div class='new-credentials'>

          <h4 class="mt-0 title is-4 uc">aggiungi nuove credenziali</h4>

          <div class="credentials">

            <label for="">Username&Password</label>
            <input class="username" type="text" placeholder="username" v-model="nuove_credenziali.username">
            <v-password class="password" type="password" placeholder="password" v-model="nuove_credenziali.password" />
            <v-password class="conferma_password" type="password" placeholder="conferma password" v-model="nuove_credenziali.conferma_password" />

          </div>

          <div class="info">

            <v-checkbox :label="'Attiva subito le credenziali dell\'utente'" v-model="nuove_credenziali.attivo" :selected="nuove_credenziali.attivo" />

            <section class="email block mt-4">
              <label for="email" placeholder="@">Indirizzo email associato all'account</label>
              <input type="email" class="email" v-model="nuove_credenziali.email"/>
              <v-checkbox :label="'Comunicare le nuove credenziali all\'utente via email'" v-model="invio_email" :selected="invio_email"/>
            </section>

            <section class="addresses block mt-4">
              <label for="email">Indirizzi del cliente associati all'account</label>
              <v-select class="addresses"
                v-model="nuove_credenziali.indirizzi"
                :options="customer.indirizzi"
                label="indirizzo_giustificato" 
                multiple
              />
            </section>

            <button class="belt-btn animated" :class="{loading: loading}" @click="createCredentials()" :disabled="!validForm">Crea credenziali</button>

          </div>

        </div>

      </div>

    </transition>

  </div>

</template>

<script>
import singleCredential from './single-credential.vue'

export default{

  components: { singleCredential },

  props: ['customer'],

  data: function(){

    return {

      loading: false,
      show: false,

      // ... modal data
      nuove_credenziali: {
        username: null,
        password: null,
        conferma_password: null,
        email: null,
        attivo: true,
        indirizzi: []      
      },
      invio_email: true,
    }

  },

  computed: {

    validForm(){

      return (this.nuove_credenziali.username && this.nuove_credenziali.username != '') 
              && 
             (this.nuove_credenziali.email && this.nuove_credenziali.email != '') 
             &&
             (this.nuove_credenziali.indirizzi.length > 0)
             && 
             (this.nuove_credenziali.password && this.nuove_credenziali.password != '')
             && 
             (this.nuove_credenziali.conferma_password && this.nuove_credenziali.conferma_password != '' && this.nuove_credenziali.conferma_password == this.nuove_credenziali.password);
    }

  },

  methods: {

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 400, this);

    },

    resetForm(){

      this.nuove_credenziali.email = null;
      this.nuove_credenziali.username = null;
      this.nuove_credenziali.password = '';
      this.nuove_credenziali.conferma_password = '';
      this.nuove_credenziali.indirizzi = [];

    },

    createCredentials: function(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/assign-credentials',
        data: {
          id_utente: vue.customer.id,
          username: vue.nuove_credenziali.username,
          password: vue.nuove_credenziali.password,
          email: vue.nuove_credenziali.email,
          attivo: vue.nuove_credenziali.attivo,
          indirizzi: vue.nuove_credenziali.indirizzi,
          invio_email: vue.invio_email,
        }
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });
        vue.pushNewCredential( res.data.credential );
        vue.resetForm()

      })
      .catch(err => {

        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message,
          autoclose: false
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    pushNewCredential: function(credential){

      this.$parent.customer.credenziali.push(credential);

    },

    splitCredential: function(id){

      var index = _.findIndex( this.customer.credenziali, val => {
        return val.id == id;
      });

      this.customer.credenziali.splice(index, 1);

    }

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.manage_credentials = false;

  }

}
</script>

<style lang="scss" scoped>
.modal-custom{
  max-width: 800px;
}
ul.credentials-list{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul.credentials-list li{
  width: 100%;
}
div.new-credentials{
  margin: 2em 0;
}
input.username,
.v-password input,
input.email,
input.conferma_password{
  padding: 10px 5px;
  width: 100%;
  border: 1px solid gray;
}
.addresses ul.vs__dropdown-menu{
  width: 100%;
  max-width: 100%;
}
</style>
